import { render, staticRenderFns } from "./NewEditEducacaoInclusivaPage.vue?vue&type=template&id=a2e1b81a"
import script from "./NewEditEducacaoInclusivaPage.vue?vue&type=script&lang=js"
export * from "./NewEditEducacaoInclusivaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports